import { SimpleGrid, Body, Box, Divider, Link } from '@hover/blueprint';
import React from 'react';
import { IJob } from '../../../interfaces/IJob';

interface Props {
  openRole: IJob;
}

const OpenRole: React.FC<Props> = ({ openRole }) => (
  <Box flexDir="column" w="100%">
    <Link
      href={`${process.env.GATSBY_V2_PREFIX}/job-details/${openRole.id}`}
      _hover={{ textDecoration: 'none', backgroundColor: 'brandTan.200' }}
    >
      <SimpleGrid
        pl={400}
        columns={2}
        w="100%"
        py={500}
        alignItems={{ base: 'flex-start', desktop: 'center' }}
      >
        <Body size={500} isSemiBold mr={100}>
          {openRole.title}
        </Body>
        <SimpleGrid columns={2}>
          <Body size={500}>{openRole.department}</Body>
          <Body textAlign={{ base: 'center', desktop: 'left' }} size={500}>
            {openRole.office}
          </Body>
        </SimpleGrid>
      </SimpleGrid>
    </Link>
    <Divider color="neutral.500" opacity={1} />
  </Box>
);

export default OpenRole;
